export const onlineRus = {
    "online.stage.loading": "Загружаем модуль связи…",
    "online.stage.signaling": "Подключаемся к сервису связи…",
    "online.stage.peer": "Устанавливаем связь с ведущим…",
    "online.stage.handshake": "Получаем данные комнаты…",
    "online.retrying": "Связь не установлена. Скоро повторим попытку…",
    "online.incoming": "Входящих подключений",
    "online.incomingFailed": "Участник попытался подключиться, но канал связи не открылся. Проверьте, что Wi-Fi разрешает связь между устройствами. В некоторых сетях нужен TURN-сервер.",
    "online.directFailed": "Не удалось открыть прямой канал с ведущим. Даже в одной Wi-Fi сети связь может блокироваться роутером или браузером. Проверьте ограничения сети; для обхода таких ограничений нужен рабочий TURN-сервер.",
    "online.hostUnavailable": "Ведущий недоступен. Убедитесь, что общий экран открыт и ссылка комнаты актуальна.",
    "online.invalidIceConfig": "Некорректная конфигурация STUN/TURN. Проверьте настройки подключения сайта.",
    "table.title": "Общий стол",
    "table.intro": "Одно поле на большом экране, личные плитки и управление — на телефонах игроков.",
    "table.create": "Открыть общий стол",
    "table.hostHint": "Этот экран — общее поле. Каждый из 2–4 игроков подключается со своего телефона по QR-коду. Сам экран не занимает место игрока.",
    "table.controllerHint": "Вы подключены как игрок. После начала партии телефон станет вашим пультом, а поле останется на общем экране.",
    "table.controller": "Ваш пульт",
    "table.hand": "Ваши закрытые плитки",
    "table.tile": "Плитка",
    "table.lookAtScreen": "Смотрите на общий экран: стрелками перемещайте маркер, затем подтвердите постановку.",
    "table.waiting": "Пока ходит другой игрок, вы можете рассмотреть свои плитки.",
    "table.move": "Переместить маркер",
    "table.cursor": "Выбранная ячейка",
    "table.invalidCell": "Здесь поставить нельзя. Переместите маркер на свободную ячейку или поверните плитку.",
    "table.yourGems": "Ваши камни и очки",
    "table.amber": "Янтарь",
    "table.emerald": "Изумруды",
    "table.sapphire": "Сапфир",
    "table.fullscreen": "Полноэкранный режим",
    "table.rulesHint": "У каждого две закрытые плитки. Выберите одну, поставьте её и доберите новую. Собранные камни и очки видны только владельцу до конца партии.",
    "online.qrLabel": "QR-код приглашения в комнату",
    "online.qrHint": "Сканируйте камерой телефона, чтобы присоединиться к игре",
    "online.closeRoom": "Закрыть комнату для всех",
    "online.forget": "Забыть комнату",
    "online.forgetHint": "Удалить сохранение комнаты только на этом устройстве",
    "online.forgetFailed": "Не удалось удалить сохранение комнаты из браузера. Проверьте доступ к хранилищу и повторите попытку.",
    "online.roomClosed": "Комната закрыта",
    "online.roomClosedHint": "Ведущий завершил комнату. Продолжить эту партию нельзя — можно создать новую игру.",
    "online.privateTile": "Ваша закрытая плитка",
    "online.hiddenTilesHint": "У каждого одна закрытая плитка. Вы видите свою заранее; соперники увидят её только после постановки. После хода вы сразу получаете следующую.",
    "online.entry": "Играть по ссылке",
    "online.resume": "Вернуться в сетевую комнату",
    "online.title": "Игра по ссылке",
    "online.intro": "2–4 игрока, каждый в своём браузере. Создайте комнату и отправьте друзьям приглашение.",
    "online.name": "Ваше имя",
    "online.create": "Создать комнату",
    "online.link": "Ссылка или код комнаты",
    "online.join": "Присоединиться",
    "online.networkHint": "Соединение через PeerJS. Ведущий должен оставаться в комнате до конца партии.",
    "online.localBack": "Назад к игре на одном устройстве",
    "online.roomTitle": "Комната Indigo",
    "online.inviteHint": "Пригласите друзей и начните игру.",
    "online.connecting": "Подключение к комнате…",
    "online.invitation": "Приглашение",
    "online.copy": "Скопировать ссылку",
    "online.copied": "Ссылка скопирована",
    "online.you": "вы",
    "online.host": "ведущий",
    "online.connected": "в сети",
    "online.offline": "нет связи",
    "online.reconnect": "Повторить подключение",
    "online.leave": "Выйти из комнаты",
    "online.savedHint": "Партия сохранится на этом устройстве. После возвращения по той же ссылке ваше место восстановится.",
    "online.waitingStart": "Игру начинает ведущий, когда все участники подключатся.",
    "online.yourTurn": "Ваш ход",
    "online.pending": "Подтверждение хода…",
    "online.waiting": "Ждём подключения игроков",
    "online.roomMenu": "Комната",
    "online.noConnection": "Нет соединения",
    "online.invalidLink": "Неверная ссылка или код комнаты.",
    "online.noSaved": "Сохранённая комната не найдена. Откройте ссылку-приглашение.",
    "online.unavailable": "Комната уже открыта в другой вкладке или WebRTC недоступен. Закройте другую вкладку и повторите подключение.",
    "online.connectFailed": "Не удалось соединиться. Ведущий должен держать комнату открытой. Проверьте сеть и повторите подключение.",
    "online.signalLost": "Связь с сервисом подключения потеряна. Переподключаемся…",
    "online.closed": "Соединение закрыто. Переподключаемся…",
    "online.loadFailed": "Не удалось загрузить сетевой модуль. Проверьте интернет.",
    "online.version": "Несовместимая версия игры. Обновите страницу.",
    "online.hostTaken": "Место ведущего уже занято.",
    "online.started": "Партия уже началась. Подключиться могут только её участники.",
    "online.full": "В комнате уже четыре игрока.",
    "online.denied": "Подключение отклонено.",
    "online.moveRejected": "Ход не принят: состояние изменилось или место недоступно. Выберите плитку заново.",
    "online.hostLost": "Связь с ведущим потеряна. Партия сохранена; переподключаемся…",
    "online.timeout": "Соединение не установлено. Убедитесь, что ведущий онлайн; попробуйте другую сеть.",
    "online.player": "Игрок",
}

export const onlineEng: Record<keyof typeof onlineRus, string> = {
    "online.stage.loading": "Loading connection module…",
    "online.stage.signaling": "Connecting to signaling service…",
    "online.stage.peer": "Connecting to the host…",
    "online.stage.handshake": "Receiving room data…",
    "online.retrying": "Connection failed. Retrying shortly…",
    "online.incoming": "Incoming connections",
    "online.incomingFailed": "A player tried to join, but the data channel did not open. Check whether the Wi-Fi network allows devices to communicate. Some networks require a TURN server.",
    "online.directFailed": "Could not open a direct channel to the host. Routers or browsers can block peer connections even on the same Wi-Fi network. Check network restrictions; a working TURN server is needed to bypass them.",
    "online.hostUnavailable": "The host is unavailable. Check that the shared screen is open and the room link is current.",
    "online.invalidIceConfig": "Invalid STUN/TURN configuration. Check the site's connection settings.",
    "table.title": "Shared table",
    "table.intro": "One board on the big screen; private tiles and controls on each player's phone.",
    "table.create": "Open shared table",
    "table.hostHint": "This is the shared board. Each of the 2–4 players joins on their phone using the QR code. This screen does not take a player seat.",
    "table.controllerHint": "You have joined as a player. Once the game starts, your phone becomes your controller; the board stays on the shared screen.",
    "table.controller": "Your controller",
    "table.hand": "Your private tiles",
    "table.tile": "Tile",
    "table.lookAtScreen": "Watch the shared screen: move the marker with the arrows, then confirm placement.",
    "table.waiting": "You can study your tiles while another player takes their turn.",
    "table.move": "Move marker",
    "table.cursor": "Selected cell",
    "table.invalidCell": "You cannot place here. Move to an empty cell or rotate your tile.",
    "table.yourGems": "Your gems and points",
    "table.amber": "Amber",
    "table.emerald": "Emeralds",
    "table.sapphire": "Sapphire",
    "table.fullscreen": "Toggle fullscreen",
    "table.rulesHint": "Each player holds two private tiles. Choose one, place it, and draw a replacement. Collected gems and scores are visible only to their owner until the game ends.",
    "online.qrLabel": "Room invitation QR code",
    "online.qrHint": "Scan with your phone camera to join the game",
    "online.closeRoom": "Close room for everyone",
    "online.forget": "Forget room",
    "online.forgetHint": "Delete the room save on this device only",
    "online.forgetFailed": "Could not delete the room save. Check browser storage access and try again.",
    "online.roomClosed": "Room closed",
    "online.roomClosedHint": "The host has closed the room. This game cannot be resumed — you can start a new one.",
    "online.privateTile": "Your private tile",
    "online.hiddenTilesHint": "Each player holds one private tile. You can see yours in advance; opponents see it only after placement. Draw a replacement immediately after your turn.",
    "online.entry": "Play by invitation",
    "online.resume": "Return to online room",
    "online.title": "Play by invitation",
    "online.intro": "2–4 players, each in their own browser. Create a room and invite your friends.",
    "online.name": "Your name",
    "online.create": "Create room",
    "online.link": "Room link or code",
    "online.join": "Join",
    "online.networkHint": "Connected using PeerJS. The host must keep the room open until the game ends.",
    "online.localBack": "Back to play on one device",
    "online.roomTitle": "Indigo room",
    "online.inviteHint": "Invite your friends and start the game.",
    "online.connecting": "Connecting to room…",
    "online.invitation": "Invitation",
    "online.copy": "Copy link",
    "online.copied": "Link copied",
    "online.you": "you",
    "online.host": "host",
    "online.connected": "online",
    "online.offline": "offline",
    "online.reconnect": "Reconnect",
    "online.leave": "Leave room",
    "online.savedHint": "The game is saved on this device. Return using the same link to reclaim your seat.",
    "online.waitingStart": "The host starts the game once everyone is connected.",
    "online.yourTurn": "Your turn",
    "online.pending": "Confirming move…",
    "online.waiting": "Waiting for players to connect",
    "online.roomMenu": "Room",
    "online.noConnection": "Not connected",
    "online.invalidLink": "Invalid room link or code.",
    "online.noSaved": "Saved room not found. Open the invitation link.",
    "online.unavailable": "The room is already open in another tab, or WebRTC is unavailable. Close the other tab and reconnect.",
    "online.connectFailed": "Could not connect. The host must keep the room open. Check your network and reconnect.",
    "online.signalLost": "Signaling connection lost. Reconnecting…",
    "online.closed": "Connection closed. Reconnecting…",
    "online.loadFailed": "Could not load the networking module. Check your internet connection.",
    "online.version": "Incompatible game version. Reload the page.",
    "online.hostTaken": "The host seat is already taken.",
    "online.started": "The game has already started. Only its existing players can reconnect.",
    "online.full": "The room already has four players.",
    "online.denied": "Connection rejected.",
    "online.moveRejected": "Move rejected: the game changed or this placement is unavailable. Select the tile again.",
    "online.hostLost": "Connection to the host lost. Your game is saved; reconnecting…",
    "online.timeout": "Connection timed out. Check that the host is online; try another network.",
    "online.player": "Player",
}
